import { HUB_SETTINGS } from 'EmailEditorUI/constants/HubSettingsForEditor';
import { MODULE_IDS_SEPARATOR } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
// @ts-expect-error not migrated yet
import { setHubSetting } from 'LayoutBuilderUI/actions/CrossFrameActions';
const storeInRecentlyUsedModules = (item, recentlyUsedModulesIds, isTemplateEditor) => {
  if (item.moduleSpec && item.moduleSpec.moduleId) {
    const id = item.moduleSpec.moduleId;
    const ids = recentlyUsedModulesIds;
    if (!ids.includes(id)) {
      let newIds = ids.length >= 4 ? ids.slice(0, 3) : [...ids];
      newIds = [id, ...newIds];
      setHubSetting({
        key: HUB_SETTINGS.RECENTLY_USED_MODULES,
        value: `${newIds.join(MODULE_IDS_SEPARATOR)}`,
        isTemplateEditor
      });
    }
  }
};
export default storeInRecentlyUsedModules;